import BaseForgeCustomizer from '../../base-forge';
import React from 'react';
import { enrolledFactorsDuringVerification } from '../../../utils/widget-facade';
import { isAnetUser } from '../../../utils/user-utils';
import Footer from '../../../components/mfa-verify/Footer';
import { createWrapper } from '../../../utils/react-utils';
import ResetAccountSection from '../../../components/mfa-verify/ResetAccountSection';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import { APP_TYPES, AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT } from '../../../constants';

const CHALLENGE_POLL = 'challenge-poll';
export default abstract class BaseMfaVerifyOieCustomizer extends BaseForgeCustomizer {
  displayFooterText = isAnetUser();

  protected forgifyController() {
    this.onIdxProceed();
    super.forgifyController();
    this.addResetAccountSection();
  }

  protected onIdxProceed() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const {
      oktaSignIn: { authClient },
    } = this;
    const originalProceed = authClient.idx.proceed.bind(authClient);
    authClient.idx.proceed = async (...args: any) => {
      const response = await originalProceed.apply(authClient, args);
      if (response.requestDidSucceed) {
        const amplitudeEventName = `${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[self.context.authenticatorKey]}::Success`;
        // For the challenge-poll step, the next step can either be challenge-poll (indicating that the
        // user has not yet verified their Okta Verify factor) or something else (indicating that
        // the user has successfully verified their Okta Verify factor).
        if (args[0].step === 'challenge-authenticator' || (args[0].step === CHALLENGE_POLL && response.nextStep?.name !== CHALLENGE_POLL)) {
          AmplitudeUtils.logMfaChallengeEvent(amplitudeEventName);
        }
      }
      return response;
    };
  }
  protected getFooter({ footerLink }: { footerLink: JQuery }): React.JSX.Element {
    const moreThanOneFactorEnrolled = enrolledFactorsDuringVerification().length > 1;

    if (moreThanOneFactorEnrolled) {
      footerLink = footerLink.not('[data-se=cancel]');
    }
    const shouldAppTypeDisplayResetAccountLink =
      settings.appType ?
        ![ APP_TYPES.ATHENISTA, APP_TYPES.ATHENANET_USER ].includes(settings.appType) : true;
    const shouldDisplayResetAccountLink =
      !settings.hideResetAccountOption && !isAnetUser() && shouldAppTypeDisplayResetAccountLink;
    return (
      <Footer
        text={this.footerText}
        footerLinks={footerLink}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
        displayResetAccountLink={shouldDisplayResetAccountLink}
      />
    );
  }

  private addResetAccountSection() {
    const wrapper = createWrapper({ hidden: false });
    const formContainer: JQuery<HTMLElement> = jQueryCourage('[data-se="o-form-content"]');
    formContainer.append(wrapper);
    this.renderReactComponent({
      id: 'reset-account-section-id',
      container: wrapper,
      className: 'reset-account-section',
      component: <ResetAccountSection />,
    });
  }
}
